// extracted by mini-css-extract-plugin
module.exports = {"shared":"\"../../../shared.module.css\"","md":"768px","lg":"992px","subheader":"HowRedeemWorks_subheader__2qRqV","howRedeemWorks":"HowRedeemWorks_howRedeemWorks__14Gnt"};